import {Component, Input, OnInit} from '@angular/core';
import {ConflictingTimetableEntriesMessage, PlainErrorMessage, UserErrors} from '../models';
import {TimetableEntry} from '../shared/TimetableEntry';

@Component({
    selector: 'edu-udo-itmc-dev-mini-book-error-renderer',
    templateUrl: './error-renderer.component.html',
    styleUrls: ['./error-renderer.component.css'],
    standalone: false
})
export class ErrorRendererComponent implements OnInit {

  @Input()
  errors?: UserErrors;

  constructor() { }

  ngOnInit(): void {
  }

  plainErrorMessages(): PlainErrorMessage[] {
    if (this.errors) {
      return this.errors.messages
        .filter(m => m.type == 'PlainErrorMessage')
        .map(m => <PlainErrorMessage>m);
    } else {
      return [];
    }
  }

  conflictingTimetableEntries(): TimetableEntry[] {
    if (this.errors) {
      const result: TimetableEntry[] = [];
      this.errors.messages
        .filter(m => m.type == 'ConflictingTimetableEntriesMessage')
        .map(m => <ConflictingTimetableEntriesMessage>m)
        .filter(m => m.timetableEntries)
        .forEach(m => m.timetableEntries.forEach(te => result.push(te)));
      return result;
    } else {
      return [];
    }
  }
}
